export const pluralise = (count, text, suffix = 's') => {
  if (count === 1) {
    return `${count} ${text}`;
  }

  return `${count} ${text}${suffix}`;
};
